import { render, staticRenderFns } from "./ReplyComposer.vue?vue&type=template&id=30475f3a&scoped=true"
import script from "./ReplyComposer.vue?vue&type=script&lang=js"
export * from "./ReplyComposer.vue?vue&type=script&lang=js"
import style0 from "./ReplyComposer.vue?vue&type=style&index=0&id=30475f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30475f3a",
  null
  
)

export default component.exports